import { apiClient } from '@/shared/lib/axios';
import { useQuery } from '@tanstack/react-query';

type InsurerType = {
  id: string;
  name: string;
};

type Response<T> = {
  data: T[];
};

export const getInsurerType = async (siteType: string | null): Promise<Response<InsurerType>> => {
  const response = await apiClient.get<Response<InsurerType>>(
    `/admin/${siteType}/master-data/insurer-types`
  );
  return response.data;
};

export const useAdminInsurerType = (siteType: string | null) => {
  return useQuery({
    queryKey: ['insurer-types', siteType],
    queryFn: () => getInsurerType(siteType),
    select: res => res.data,
  });
};
